import styles from "../ContactSelector/ContactSelector.module.scss";

const SelectedCustomerItem = ({ customer, onRemove }) => {
  return (
    <div className={styles.selectedContactItem}>
      <div className={styles.contactCheckbox}>
        <button
          className={styles.removeButton}
          onClick={() => onRemove(customer.id)}
          type="button"
        >
          ×
        </button>
      </div>

      <div className={styles.contactInfo}>
        <div className={styles.contactName}>
          {customer.display_name || customer.name}
        </div>
        {customer.mc_number && (
          <div className={styles.customerName}>
            MC# {customer.mc_number}
          </div>
        )}
      </div>

      <div className={styles.activitySection}>
        <div className={styles.rfqStats}>
          <div className={styles.statItem}>
            <span className={styles.statValue}>{customer.rfqs_30d || 0}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectedCustomerItem;
